import {Component, NgModule} from '@angular/core';
import { navItems } from '../../_navcourier';
import { navItems1 } from '../../_navcouriercustomer';
import { navItems2 } from '../../_navcourierbranch';
import { navItems3 } from '../../_navcouriercustomermis';
import { navItems4 } from '../../_navcourierbranchadmin';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
@NgModule({
  
  imports: [NgxSpinnerModule],
  
  
})
export class DefaultLayoutComponent {
  public sidebarMinimized = false;
  public navItems = navItems3;
  ngOnInit(): void {
    let  user = localStorage.getItem('piyushUser');
    if(user == "Customer")
      this.navItems =navItems1;
    else if(user == "BranchUser" || user == "DeliveryBoy")
      this.navItems = navItems2;
    else if(user == "CustomerMIS")
      this.navItems = navItems3;
    else if(user == "Admin")
      this.navItems = navItems;
    else if(user == "BranchAdmin")
      this.navItems = navItems4;
      
  }
  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
}
